import { romanize } from 'romans'

const getRomanNumeral = (value) => {
  if (Number.isInteger(value) && value > 0 && value < 4000) {
    return romanize(value)
  }

  return value
}

export { getRomanNumeral }
